import React from 'react';
import PropTypes from 'prop-types';
export { Radio } from './Radio';

const RadioGroup = props => {
	const { children, name, onClick, onChange, value, ...rootProps } = props;
	const isControlled = 'value' in props;

	return (
		<div {...rootProps}>
			{React.Children.map(children, radio => {
				let childProps = { name, onClick, onChange };

				if (isControlled) {
					childProps = {
						...childProps,
						checked: radio.props.value === value,
					};
				}

				return React.cloneElement(radio, childProps);
			})}
		</div>
	);
};

RadioGroup.propTypes = {
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
};

RadioGroup.defaultProps = {
	onChange: () => {},
};

export default RadioGroup;
